export const common = {
  nav_home: 'Home',
  nav_quiz: 'Take the Quiz',
  nav_decision_tree: 'Decision Tree',
  nav_about: 'About',
  nav_contact: 'Contact',
  nav_cta: 'Take the Quiz',
  lang_en: 'EN',
  lang_es: 'ES',
  footer_tagline: 'Communicate with clarity. Handle conflict with confidence. Lead with calm authority.',
  footer_quick_links: 'Quick Links',
  footer_resources: 'Resources',
  footer_contact: 'Contact',
  footer_copyright: '\u00A9 {year} Calm Authority. All rights reserved. Materials, resources and course content may not be reproduced, distributed or shared without written permission.',
};